import React, { useEffect,useState,useContext } from 'react'
import { TextField, Grid, Box, Button,OutlinedInput,IconButton,InputAdornment,FormHelperText } from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DriveUsOneSchema } from '../../Utils/Validations'
import { usePlacesWidget } from "react-google-autocomplete";
import AuthState from '../../Hooks/Authinctication.state'
import {Visibility,VisibilityOff} from '@mui/icons-material'
import { UserContext } from 'Hooks/UserContext'

const DriveWithUsOne = ({ handleBack, handleComplete, driveUsData, setDriveUsData }) => {
  const [email,setEmail] = useState("")
  const [first_name,setFirst_name] = useState("")
  const [last_name,setLast_name] = useState("")
  const [error,setError] = useState("")
  const [showPassword,setShowPassword] = useState(false)
  const {checkPasswordStrength,passwordStatus} = useContext(UserContext)
  const [password,setPassword]  = useState("")
  const {CheckUser,message,formBusy} = AuthState()
  const { handleSubmit, control, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(DriveUsOneSchema)
  })
  useEffect(() => {
    setValue("first_name", driveUsData.first_name || "")
    setValue("last_name", driveUsData.last_name || "")
    setValue("company", driveUsData.company || "")
    setValue("email", driveUsData.email || "")
    setValue("password", driveUsData.password || "")
    setValue("cPassword", driveUsData.password || "")
   
  }, [])
  const onSubmit = async (data) => {
    console.log(data)
    await CheckUser({email:data.email})
  }



useEffect(()=>{
  if(message?.type==="error"){
    setError(message.message)
  }else if(errors?.email){
    setError(errors.email.message)
  }else{
    setError("")
  }
  if(message?.type==="success"){
    setDriveUsData((prev) => ({ ...prev, first_name: first_name,last_name:last_name,email:email,password:password}))
    handleComplete()
  }
},[message,errors])

const handleClickShowPassword = () => {
  setShowPassword(!showPassword);
};

const handleMouseDownPassword = (event) => {
  event.preventDefault();
};
//   const { ref } = usePlacesWidget({
//     apiKey: 'AIzaSyBy2l4KGGTm4cTqoSl6h8UAOAob87sHBsA',
//     onPlaceSelected: (place) => {
//         const addresses = place?.formatted_address;
//         console.log("Old Data....",addresses);
//         setValue("address",addresses)
//         setDriveUsData((prev) => ({ ...prev, address:addresses}))
        
       
//     },
//     options: {
//         types: ["(regions)"]
//     }
    
//  } 

 
//  )

  return (
    <div>

      <Grid container style={{ justifyContent: "center", marginTop: 20 }} >
        <Grid sm={4} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 } }}>
          <Controller
            control={control}
            name="first_name"
            rules={{ required: true }}
            render={({ field: { onChange, value } }) => (
              <>
                <label>Your Full Name</label>
                <TextField fullWidth placeholder='First Name' value={value} onChange={(e) => { onChange(e); setFirst_name(e.target.value) }} error={errors?.first_name} helperText={errors?.first_name?.message} />
              </>
            )}
          />
        </Grid>

        <Grid sm={4} xs={12} sx={{ textAlign: "left", px: { sm: 1, xs: 0 }, mt: { sm: 0, xs: 2 } }}>
          <Controller
            control={control}
            name="last_name"
            rules={{ required: true }}
            render={({ field: { onChange, value } }) => (
              <>
                <label>Last Name</label>
                <TextField fullWidth placeholder='Last Name' value={value} onChange={(e) => { onChange(e); setLast_name(e.target.value) }} error={errors?.last_name} helperText={errors?.last_name?.message} />
              </>
            )}
          />
        </Grid>

        <Grid sm={4} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 }, mt: { sm: 0, xs: 2 } }}>
          <Controller
            control={control}
            name="company"
            render={({ field: { onChange, value } }) => (
              <>
                <label>Company</label>
                <TextField
                  fullWidth
                  placeholder='Company'
                  value={value}
                  onChange={(e) => { onChange(e); setDriveUsData((prev) => ({ ...prev, company: e.target.value })) }}
                  error={errors?.company}
                  helperText={errors?.company?.message}
                />
              </>
            )}
          />
        </Grid>

        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 }, mt: 3 }}>
          <Controller
            control={control}
            name="email"
            rules={{ required: true }}
            render={({ field: { onChange, value } }) => (
              <>
                <label>Email Address</label>
                <TextField fullWidth placeholder='Email Address' value={value} onChange={(e) => { onChange(e); setEmail(e.target.value) }} error={error} helperText={error} />
              </>
            )}
          />
        </Grid>

        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 }, mt: 3 }}>
          <label>Started from</label>
          <TextField
            fullWidth
            type="date"
            value={driveUsData.started_from || new Date().toISOString().split('T')[0]}
            onChange={(e) => setDriveUsData((prev) => ({ ...prev, started_from: e.target.value }))}
            sx={{
              "& input[type=date]::-webkit-calendar-picker-indicator": {
                filter: "invert(1)",
                opacity: 1,
                cursor: "pointer",
              },
            }}
          />
        </Grid>
        <Grid sm={6} xs={12} sx={{textAlign:"left",paddingRight:{sm:1,xs:0},mt:3}} >
            <Controller
            control={control}
            name="password"
            rules={{ required: true }}
            render={({ field:{onChange,value} }) => (
              <>
               <label>Password</label>
                <OutlinedInput 
                fullWidth 
                placeholder='Password' 
                 onChange={(e)=>{onChange(e);setPassword(e.target.value);checkPasswordStrength(e.target.value)}}
                 value={value}
                 error={errors.password} 
                 helperText={errors?.password?.message} 
                 type={showPassword ? 'text' : 'password'}
                 
                    endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                            size="large"
                          >
                            {showPassword ? <Visibility sx={{color:"#FFF"}} /> : <VisibilityOff sx={{color:"#FFF"}} />}
                          </IconButton>
                        </InputAdornment>
                      
                 }
                 />
                 <Box sx={{display:"flex",justifyContent:"space-between"}} >
                 <FormHelperText sx={{color:"red"}} >{errors?.password?.message}</FormHelperText>
                 <FormHelperText sx={{color:passwordStatus==="Weak"?"red":passwordStatus==="Good"?"yellow":"#97c11e"}}  >{passwordStatus}</FormHelperText>
                 </Box>
                 
              </>
            )}
          />
               
       
        
        </Grid>
        <Grid sm={6} xs={12} sx={{textAlign:"left",paddingLeft:{sm:1,xs:0},mt:3}}>
        <Controller
            control={control}
            name="cPassword"
            rules={{ required: true }}
            render={({ field }) => (
              <>
                <label> Confirm Password</label>
                <OutlinedInput 
                fullWidth 
                placeholder='Confirm Password' 
                 {...field} 
                 error={errors.cPassword} 
                 helperText={errors?.cPassword?.message} 
                 type={showPassword ? 'text' : 'password'}
                    endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                            size="large"
                          >
                            {showPassword ? <Visibility sx={{color:"#FFF"}} /> : <VisibilityOff sx={{color:"#FFF"}} />}
                          </IconButton>
                        </InputAdornment>
                      
                 }
                 />
                 <FormHelperText sx={{color:"red"}} >{errors?.cPassword?.message}</FormHelperText>
              </>
            )}
          />
       
        
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2,pb:2 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ minWidth: "10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{ minWidth: "10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          {formBusy?"Please wait...": "Next"}
        </Button>

      </Box>
    </div>
  )
}

export default DriveWithUsOne